import React from "react";
import { Box, Typography } from "@mui/material";
import BrandLogo from "../components/BrandLogo";
import AuthHero from "../components/AuthHero";
import { authCardSx } from "../theme/authStyles";
import { BRAND } from "../constants/colors";

const BLUE = BRAND.primary;

export default function AuthLayout({ title, subtitle, children, footer, maxWidth = 440 }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        background: "#0B0B0B",
      }}
    >
      <Box
        sx={{
          flex: { md: "0 0 44%" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          px: { xs: 3, md: 6 },
          py: { xs: 3, md: 6 },
          position: "relative",
          overflow: "hidden",
          background: "#0B0B0B",
          minHeight: { xs: "auto", md: "100vh" },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: 520,
            height: 220,
            borderRadius: "50%",
            right: -160,
            top: -70,
            background: BLUE,
            transform: "rotate(-22deg)",
            opacity: 0.92,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(11,11,11,0.2) 0%, rgba(11,11,11,0.55) 55%, #0B0B0B 100%)",
          }}
        />

        <Box sx={{ position: "relative", zIndex: 1 }}>
          <BrandLogo size={36} inverted showTagline={false} wordmarkSize={16} />
        </Box>

        <Box sx={{ position: "relative", zIndex: 1, py: { xs: 3, md: 4 } }}>
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 700,
              fontSize: { xs: 26, md: 34 },
              letterSpacing: "-0.03em",
              lineHeight: 1.15,
              mb: 1.25,
              maxWidth: 360,
            }}
          >
            Plan the path.
            <Box component="span" sx={{ color: BLUE }}> Build the skill.</Box>
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.72)",
              fontSize: 14.5,
              lineHeight: 1.6,
              maxWidth: 340,
              mb: { xs: 2, md: 4 },
              fontWeight: 400,
            }}
          >
            Academic planning for SNS institutions 
          </Typography>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <AuthHero />
          </Box>
        </Box>

        <Typography
          sx={{
            position: "relative",
            zIndex: 1,
            color: "rgba(255,255,255,0.45)",
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
          }}
        >
          SNS Institutions
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F3F4F6",
          px: { xs: 2, sm: 4 },
          py: { xs: 3, md: 6 },
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: "100%", maxWidth }}>
          <Box sx={authCardSx}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: 22, sm: 24 },
                letterSpacing: "-0.025em",
                color: "#111827",
                mb: 0.6,
                lineHeight: 1.25,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ color: "#6B7280", fontSize: 14, mb: 3, lineHeight: 1.55, fontWeight: 400 }}>
                {subtitle}
              </Typography>
            )}
            {children}
          </Box>
          {footer && (
            <Typography sx={{ textAlign: "center", mt: 2.25, fontSize: 14, color: "#6B7280", fontWeight: 400 }}>
              {footer}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
